import React from 'react';
import { AppProvider, useApp } from './context/AppContext';
import ConnectionScreen from './components/ConnectionScreen';
import Dashboard from './components/Dashboard';
import AddUserScreen from './components/AddUserScreen';
import QueryScreen from './components/QueryScreen';
import MissionScreen from './components/MissionScreen';
import VisualizationScreen from './components/VisualizationScreen';
import CompanyAgent from './components/CompanyAgent';
import Neo4jEditor from './components/Neo4jEditor';
import QueryScreenV2 from './components/QueryScreenV2';

function AppContent() {
  const { state } = useApp();

  const renderCurrentScreen = () => {
    switch (state.currentScreen) {
      case 'connection':
        return <ConnectionScreen />;
      case 'dashboard':
        return <Dashboard />;
      case 'addUser':
        return <AddUserScreen />;
      case 'query':
        return <QueryScreen />;
      case 'mission':
        return <MissionScreen />;
      case 'visualization':
        return <VisualizationScreen />;
      case 'company':
        return <CompanyAgent />;
      case 'editor':
        return <Neo4jEditor />;
      case 'queryV2':
        return <QueryScreenV2 />;
      default:
        return <ConnectionScreen />;
    }
  };

  return (
    <div className="bg-gray-900 text-white flex items-center justify-center min-h-screen p-4">
      <div className="w-full max-w-6xl">
        {renderCurrentScreen()}
      </div>
    </div>
  );
}

function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}

export default App;
